module.exports = __webpack_public_path__ + "img/neobet.7c1e6380.png";